import { combineReducers } from "redux";
import sidebarReducer from "./Sidebar/sidebarSlice";
import accessReducer from "./Access/accessSlice";
import userReducer from "./User/userSlice";
import storage from "redux-persist/lib/storage";
import appReducer from "./App/AppSlice";
import deviceReducer from "./Device/deviceSlice";
import customerReducer from "./Customer/customerSlice";
import customersModalReducer from "./SuperAdminModal/modalSlice";
import autoLogoutReducer from "./AutoLogout/autoLogoutSlice";
import { persistReducer } from "redux-persist";

const persistConfig = {
  key: "core",
  storage,
  blacklist: ["sidebar", "device"],
  whitelist: [
    "user",
    "access",
    "extension",
    "jitsi",
    "app",
    "notification",
    "customer",
    "customersModal",
    "autoLogout",
  ],
};

const rootReducer = combineReducers({
  sidebar: sidebarReducer,
  access: accessReducer,
  user: userReducer,
  app: appReducer,
  device: deviceReducer,
  customer: customerReducer,
  customersModal: customersModalReducer,
  autoLogout: autoLogoutReducer,
});

export default persistReducer(persistConfig, rootReducer);
